import React from "react";
import middleware from "./middleware/middleware";
import Report from "../component/sections/report/Report";

const sitesRoutes = [
  {
    path: "/report",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <Report />,
        "Report"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
